import { lazy } from 'react';
export const FullReportPage = lazy(() => import(/* webpackChunkName: "admin-full-report" */ '.'));
export default FullReportPage;
